module.exports = __webpack_public_path__ + "static/media/SquareBottomAdPreview.104777b9.svg";